import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as Actions from "../actions/RemoveUserFromOrganization";

export function* removeUserFromOrganization(action: Actions.RemoveUserFromOrganizationAction) {
    const { payload } = action;
    const { credentials, organizationId, userId, opts } = payload;

    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });
        yield put(loading(true, action));
        yield api.removeUserFromOrganization(organizationId, userId, opts);
        yield put(addNotification("User Removed"));
        yield put(Actions.removeUserFromOrganizationEnd(undefined, organizationId, userId, opts));
    } catch (e) {
        yield put(addNotification(e.message, true));
        yield put(Actions.removeUserFromOrganizationEnd(e, organizationId, userId, opts));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchRemoveUserFromOrganization() {
    yield takeEvery(Actions.REMOVE_USER_FROM_ORGANIZATION, removeUserFromOrganization);
}
